import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import * as actions from '../redux/actions/index';
import StateMap from "../charts/StateMap/index";

import ScatterPlot from '../charts/ScatterPlot/index';

import './StateCard.css';

class StateComboCard extends Component {
  render() {
    const selectCounty = countyFips => {
      this.props.actions.selectCounty(countyFips);
      this.props.actions.selectPage('county');
    };

    return (
      <Card className="StateCard" noHovering={true} loading={this.props.loading}>
        <Row gutter={10}>
          <h2 className="subtitle">
            {this.props.stateName} Multivariate by County - {this.props.year}<br/>
            <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e04040"></rect></svg>
            {this.props.xLabel} &nbsp;
            <small>vs</small> &nbsp;
            <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#0f8ee9"></rect></svg>
            {this.props.yLabel}
          </h2>
          <Col xs={24} md={14}>
            <StateMap
              type={'z'}
              stateFips={this.props.states.selected.fips}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              dimX={this.props.xField}
              dimY={this.props.yField}
              dict={this.props.dict}
              data={this.props.data}
              year={this.props.year}
              showCities={true}
              onClick={(stateFips, countyFips) => selectCounty(countyFips)}/>
          </Col>
          <Col xs={24} md={10}>
            <ScatterPlot
              type="z"
              dimId={this.props.idField}
              dimX={this.props.xField}
              dimY={this.props.yField}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              year={this.props.year}
              data={this.props.data}
              onClick={selectCounty}/>
          </Col>
        </Row>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.counties.loading || store.dimensions.loading,
    states: store.states,
    data: store.counties.data,
    dict: store.counties.dict,
    stateName: store.states.selected.name,
    idField: store.dimensions.countyKey,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    xDesc: store.dimensions.xDesc,
    yDesc: store.dimensions.yDesc,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(StateComboCard);



// WEBPACK FOOTER //
// ./src/containers/StateComboCard.js